const useGetFaqCategoryApi = async ({
  fetchOptions,
  options,
}: {
  fetchOptions?: MaybeRef<Omit<ApiRestOptions, "params"> & { params: FaqCategoryQueryParams }>;
  options?: AsyncDataOptions<ApiRestResponse<ApiRestResult<FaqCategory>>>;
} = {}) => {
  const response = await useFetchRequest(async (defaultOptions) => {
    return getFaqCategoryApi(deepmerge(defaultOptions, unref(fetchOptions)));
  }, options);

  const item = computed(() => {
    return response.data.value?.result?.data ?? null;
  });

  return {
    ...response,
    item,
  };
};

export { useGetFaqCategoryApi };
